import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        info: {
            '& .MuiTypography-root': {
                color: palette.text.primary,
            },
        },
        titleHeader: {
            margin: theme.spacing(1, 0, 2, 0),
        },
        subtitle: {
            color: theme.palette.text.primary,
        },
    }))
